// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#order-bills {
  max-width: 1080px;
  margin: 0px 0px -10px;
}
#order-bills .k-grid {
  margin: 0px 0px 10px;
}
#order-bills .k-grid .k-detail-row .has-secondary-tabs .cp-secondary-tabs .k-content {
  padding: 20px 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/orders/modal/bills/bills.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EAEG,qBAAA;AAAJ;AACC;EACC,oBAAA;AACF;AAGG;EACC,iBAAA;AADJ","sourcesContent":["#order-bills{\n\tmax-width:1080px;\n\t//width:100vw;\n    margin: 0px 0px -10px;\n\t.k-grid{\n\t\tmargin: 0px 0px 10px;\n\t}\n\t.k-grid{\n\t\t.k-detail-row{\n\t\t\t.has-secondary-tabs .cp-secondary-tabs .k-content{\n\t\t\t\tpadding:20px 0px;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
